import { useState } from 'react'

export function useRequestProfileHeaderTranslation({
  requestText,
  ukLanguageCode,
  userLanguageCode,
}) {
  const [isRequestTranslateOpen, setRequestTranslateOpen] = useState(false)
  const [translatedDescriptionHtml, setTranslatedDescriptionHtml] =
    useState(null)

  function resetTranslation() {
    setTranslatedDescriptionHtml(null)
  }

  function handleOpenRequestTranslate() {
    setRequestTranslateOpen(true)
  }

  function handleCloseRequestTranslate() {
    setRequestTranslateOpen(false)
    resetTranslation()
  }

  function handleApplyRequestTranslation({ translatedText }) {
    setTranslatedDescriptionHtml(translatedText)
  }

  const requestTranslateProps = {
    requestText,
    ukLanguageCode,
    userLanguageCode,
    onClose: handleCloseRequestTranslate,
    onTranslate: handleApplyRequestTranslation,
  }

  return {
    descriptionHtml: translatedDescriptionHtml ?? requestText,
    isRequestTranslateOpen,
    requestTranslateProps,
    resetTranslation,
    onClickOpenRequestTranslate: handleOpenRequestTranslate,
  }
}
